
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ElfNameGenerator } from "./elf-name-generator/ElfNameGenerator";

interface EmbeddableElfNameGeneratorProps {
  title?: string;
  showHistory?: boolean;
  instanceId: string;
  postId?: string;
}

const EmbeddableElfNameGenerator: React.FC<EmbeddableElfNameGeneratorProps> = ({
  title,
  showHistory = true,
  instanceId,
  postId
}) => {
  return (
    <div className="my-8 max-w-xl mx-auto">
      <ElfNameGenerator 
        title={title}
        showHistory={showHistory}
        instanceId={instanceId}
        postId={postId}
      />
    </div>
  );
};

/**
 * Function to embed the elf name generator in any HTML element
 */
export const embedElfNameGenerator = (elementId: string, options?: {
  title?: string;
  showHistory?: boolean;
  postId?: string;
}) => {
  import('react-dom/client').then(({ createRoot }) => {
    const container = document.getElementById(elementId);
    if (container) {
      const instanceId = `${elementId}_${Math.random().toString(36).substring(2, 9)}`;
      const root = createRoot(container);
      root.render(
        <EmbeddableElfNameGenerator 
          title={options?.title}
          showHistory={options?.showHistory}
          instanceId={instanceId}
          postId={options?.postId}
        />
      );
    }
  });
};

// Make the component the default export
export default EmbeddableElfNameGenerator;
